import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import InnerHtmlContent from '../InnerHtmlContent';

const InfoBox = ({ content }) => (
  <div className="container-fluid">
    <Alert bsStyle="info"><InnerHtmlContent content={content} /></Alert>
  </div>
);

InfoBox.propTypes = {
  content: PropTypes.string.isRequired
};

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/InfoBox/index.jsx